"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSAL_INSTANCE_CONFIG = exports.IFF_TOKEN_SILENT_REQUEST = exports.IFF_LOGIN_REQUEST = void 0;
exports.IFF_LOGIN_REQUEST = {
    scopes: ["User.Read", process.env.REACT_APP_MSAL_SCOPE],
};
exports.IFF_TOKEN_SILENT_REQUEST = {
    scopes: [process.env.REACT_APP_MSAL_SCOPE],
};
exports.MSAL_INSTANCE_CONFIG = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        authority: process.env.REACT_APP_MSAL_AUTHORITY_URL,
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL,
    },
};
